import React from "react";

const KitchenCategory = ({ categories, categoryVoid }) => {
    const hasCompletedData =
        categories &&
        !categories.error &&
        Object.keys(categories).length > 0;

    const hasVoidData =
        categoryVoid &&
        !categoryVoid.error &&
        Object.keys(categoryVoid).length > 0;

    return (
        <div className="flex flex-col gap-4">

            {/* Completed */}
            <section>
                <div className="flex items-center gap-2 mb-3">
                    <span className="w-2 h-2 rounded-full bg-emerald-500" />
                    <div className="text-xs uppercase tracking-widest font-semibold text-[#8A8780]">
                        Completed
                    </div>
                </div>

                {hasCompletedData ? (
                    Object.entries(categories).map(([key, value]) => (
                        <div
                            key={key}
                            className="mb-3 border border-[#F0EDE8] rounded-md overflow-hidden"
                        >
                            <div className="bg-[#F8F7F3] px-3 py-2 border-b border-[#F0EDE8]">
                                <div className="text-sm font-semibold text-[#2C2C2A] m-0">
                                    {key}
                                </div>
                            </div>

                            <div>
                                {value.map((food, index) => (
                                    <div
                                        key={index}
                                        className="
                                            flex items-center justify-between
                                            px-3 py-2
                                            border-b border-[#F8F7F3]
                                            last:border-b-0
                                            hover:bg-[#FAFAF8]
                                            transition-colors
                                            font-semibold text-[#4B4B46] text-xs
                                        "
                                    >
                                        <span>
                                            {food.ItemName}
                                        </span>

                                        <span className="w-14 text-right pl-1">
                                            {food.quantity}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="rounded-md border border-dashed border-[#E5E2DB] bg-[#FAFAF8] py-6 text-center text-sm text-[#8A8780]">
                        No completed items
                    </div>
                )}
            </section>

            {/* Void */}
            <section>
                <div className="flex items-center gap-2 mb-3">
                    <span className="w-2 h-2 rounded-full bg-red-500" />
                    <div className="text-xs uppercase tracking-widest font-semibold text-[#8A8780]">
                        Void
                    </div>
                </div>

                {hasVoidData ? (
                    Object.entries(categoryVoid).map(([key, value]) => (
                        <div
                            key={key}
                            className="mb-3 border border-[#F0EDE8] rounded-md overflow-hidden"
                        >
                            <div className="bg-[#F8F7F3] px-3 py-2 border-b border-[#F0EDE8]">
                                <div className="text-sm font-semibold text-[#2C2C2A]">
                                    {key}
                                </div>
                            </div>

                            <div>
                                {value.map((food, index) => (
                                    <div
                                        key={index}
                                        className="
                                            flex items-center justify-between
                                            px-3 py-2
                                            border-b border-[#F8F7F3]
                                            last:border-b-0
                                            hover:bg-[#FAFAF8]
                                            transition-colors 
                                            font-semibold text-xs
                                        "
                                    >
                                        <span className="text-[#4B4B46]">
                                            {food.ItemName}
                                        </span>

                                        <span className="text-[#DC2626] w-14 text-right pl-1">
                                            {food.quantity}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="rounded-md border border-dashed border-[#E5E2DB] bg-[#FAFAF8] py-6 text-center text-sm text-[#8A8780]">
                        No void items
                    </div>
                )}
            </section>
        </div>
    );
};

export default KitchenCategory;